import React, { lazy } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Star, ArrowLeft, Clock } from 'lucide-react';
import { getBarber, useStore, handleImgError } from '../lib/store';
export function BarberProfile() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const {
    services
  } = useStore();
  const barber = getBarber(id || '');
  if (!barber) return <div className="p-6 text-light" data-id="element-793">Barbero no encontrado</div>;
  const barberServices = services.filter(s => barber.serviceIds.includes(s.id));
  return <div className="pb-24" data-id="element-794">
      <div className="relative h-64 sm:h-72" data-id="element-795">
        <img src={barber.image} alt={barber.name} onError={handleImgError} className="w-full h-full object-cover object-top bg-white/5" data-id="element-796" />
        <div className="absolute inset-0 bg-gradient-to-t from-dark to-transparent" data-id="element-797" />
        <button onClick={() => navigate(-1)} className="absolute top-6 left-6 w-10 h-10 bg-black/50 backdrop-blur-md rounded-full flex items-center justify-center text-light hover:text-gold transition-colors" data-id="element-798">
          <ArrowLeft size={20} data-id="element-799" />
        </button>
      </div>
      <div className="px-6 -mt-12 relative z-10 space-y-6" data-id="element-800">
        <div data-id="element-801">
          <h1 className="text-3xl font-bold text-light" data-id="element-802">{barber.name}</h1>
          <p className="text-gold font-medium mt-1" data-id="element-803">{barber.role}</p>
          <div className="flex items-center gap-4 mt-3 text-sm" data-id="element-804">
            <div className="flex items-center gap-1 text-gold" data-id="element-805">
              <Star size={16} fill="currentColor" data-id="element-806" />
              <span className="font-medium text-light" data-id="element-807">{barber.rating}</span>
              <span className="text-light-muted" data-id="element-808">({barber.reviews})</span>
            </div>
            <div className="w-1 h-1 rounded-full bg-white/20" data-id="element-809" />
            <span className="text-light-muted" data-id="element-810">
              {barber.experience} años exp.
            </span>
          </div>
        </div>

        <p className="text-sm text-light-muted leading-relaxed" data-id="element-811">{barber.bio}</p>

        <section data-id="element-812">
          <h3 className="text-lg font-medium text-light mb-3" data-id="element-813">Galería</h3>
          <div className="flex gap-3 overflow-x-auto scrollbar-hide -mx-6 px-6" data-id="element-814">
            {barber.gallery.map((img, i) => <img key={i} src={img} alt={`Trabajo de ${barber.name}`} loading="lazy" onError={handleImgError} className="w-28 h-28 rounded-2xl object-cover flex-shrink-0 bg-white/5" data-id="element-815" />)}
          </div>
        </section>

        <section data-id="element-816">
          <h3 className="text-lg font-medium text-light mb-3" data-id="element-817">Servicios</h3>
          <div className="space-y-3" data-id="element-818">
            {barberServices.map(s => <div key={s.id} className="bg-dark-card p-4 rounded-xl border border-white/5 flex justify-between items-center" data-id="element-819">
                <div data-id="element-820">
                  <h4 className="text-sm font-medium text-light" data-id="element-821">{s.name}</h4>
                  <p className="text-xs text-light-muted flex items-center gap-1 mt-1" data-id="element-822">
                    <Clock size={10} data-id="element-823" /> {s.duration}
                  </p>
                </div>
                <span className="text-sm font-medium text-gold whitespace-nowrap" data-id="element-824">
                  ${s.price.toLocaleString('es-UY')}
                </span>
              </div>)}
          </div>
        </section>

        <div className="fixed bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-dark via-dark to-transparent z-50 flex justify-center" data-id="element-825">
          <div className="w-full max-w-md" data-id="element-826">
            <Link to="/reservar" className="block w-full bg-gold text-dark py-4 rounded-xl font-semibold text-center shadow-lg shadow-gold/20 hover:bg-gold-hover transition-colors" data-id="element-827">
              Reservar turno
            </Link>
          </div>
        </div>
      </div>
    </div>;
}